module.exports = __webpack_public_path__ + "static/media/03.96e9910b.png";